/**
 * App Component
 * VROONG 애플리케이션 메인 컴포넌트
 */

import React from 'react';
import AppRoutes from "./AppRoutes";
import '../styles/global.css';

import { ToastContainer } from "@/shared/components/feedback/Toast/ToastContainer";
import { ToastProvider } from "@/shared/components/feedback/Toast/ToastContext";

function App() {
    return (
        <ToastProvider>
            <AppRoutes />

            <ToastContainer />
        </ToastProvider>
    )
}

export default App;
